import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  minMaxFundingError: {
    description: 'Add funds minimum funding error',
    defaultMessage: 'Minimum funding amount is {min}, the maximum funding amount is {max}.',
    id: 'el5RZk',
  },
  amountCannotBeNegative: {
    description: 'Auto fund amount cant be less than 0',
    defaultMessage: 'Value must be greater than 0.',
    id: 'b2+9Zq',
  },
  unknownErrorWithoutMessage: {
    description: 'Unknown error without message from server',
    defaultMessage: 'An unknown error occurred.',
    id: 'CId2Ig',
  },
  limitReachedHeader: {
    description: 'Header for limit reached banner',
    defaultMessage: "<b>You've reached your ${limit} spending limit.</b>",
    id: 'GBckRH',
  },
  limitPresentHeader: {
    description: 'Header for limit present banner',
    defaultMessage: '<b>Your account currently has a ${limit} spending limit.</b>',
    id: '7KMwiB',
  },
  limitMessage: {
    defaultMessage:
      'Your remaining spending limit is ${limitRemaining}. To remove the ${limit} spending limit from your account, become a verified merchant.\n<button>Verify Now</button>',
    id: 'MkbJVi',
    description: "Text for banner when user has reached their spending limit and hasn't verified",
  },
});
